import React, {useContext} from 'react'
import AppContext from '../../appContext'
import Tabs from "../../components/Tabs";
import {useNavigate} from "react-router-dom";
import PagedSearchTable from "../../components/PagedSearchTable";
import {dateFormat} from "../../date";
import LimeController from "../../controllers/LimeController";
import LimeTemplateApprovalListItem from "../../controllers/LimeTemplateApprovalListItem";
import LimeProgramApprovalListItem from "../../controllers/LimeProgramApprovalListItem";

const TemplatesApprovalLiming: React.FC = () => {
    const navigate = useNavigate()
    const app = useContext(AppContext)

    function rowClicked (item: LimeTemplateApprovalListItem) {
        navigate(`/liming/approvals/template/${item.id}`)
    }

    return <PagedSearchTable
        rowClick={item => rowClicked(item)}
        call={LimeController.templateApprovals} keyExtractor={t => t.id} columns={[
        {
            header: app.word('name'),
            row: t => t.name
        },
        {
            header: app.word('submitted_on'),
            row: t => dateFormat(t.submittedOn)
        },
        {
            header: app.word('created_by'),
            row: t => <>
                <div>{t.createdBy}</div>
                <div>{t.userEmail}</div>
            </>
        },
        {
            header: app.word('approved_on'),
            row: t => dateFormat(t.approvedOn)
        }
    ]}/>
}
const ProgramsApprovalLiming: React.FC = () => {
    const navigate = useNavigate()
    const app = useContext(AppContext)

    function rowClicked (item: LimeProgramApprovalListItem) {
        navigate(`/liming/approvals/program/${item.id}`)
    }

    return <PagedSearchTable
        rowClick={item => rowClicked(item)}
        call={LimeController.programApprovals} keyExtractor={t => t.id} columns={[
        {
            header: app.word('name'),
            row: t => t.name
        },
        {
            header: app.word('farm'),
            row: t => t.farmName
        },
        {
            header: app.word('submitted_on'),
            row: t => dateFormat(t.submittedOn)
        },
        {
            header: app.word('created_by'),
            row: t => <>
                <div>{t.createdBy}</div>
                <div>{t.userEmail}</div>
            </>
        },
        {
            header: app.word('approved_on'),
            row: t => dateFormat(t.approvedOn)
        }
    ]}/>
}
const LimingApprovals: React.FC = () => {
    return (
        <Tabs tabs={[
            {
                header: () => 'Templates',
                content: <TemplatesApprovalLiming/>,
                tag: 'templates',
                key: 'templates'
            },
            {
                header: () => 'Programs',
                content: <ProgramsApprovalLiming/>,
                tag: 'programs',
                key: 'programs'
            }
        ]}/>
    )
}

export default LimingApprovals
